<template>
    <div class="card h-100 border-radius-8 shadow" v-if="sync && sync.last || (sync && sync.next)">
        <div class="card-body">
            <h4 class="card-title font-poppins font-weight-extrabold color-blue font-size-14">
                {{ Lang.get('employerdashboard::shared.sync.status.title') }}
            </h4>
            <div class="card-text color-dark-blue font-size-14">
                <div v-if="sync.last">
                    {{ Lang.get('employerdashboard::shared.sync.status.description') }}:<br/>
                    <strong class="font-aileron-bold">
                        {{ sync.last }}
                    </strong>
                </div>

                <div v-else>
                    {{ Lang.get('employerdashboard::shared.sync.never_synced') }}
                </div>

                <br />

                <div v-if="sync.next">
                    {{ Lang.get('employerdashboard::shared.sync.status.next_sync_at') }}:<br/>
                    <strong class="font-aileron-bold">
                        {{ sync.next }}
                    </strong>
                </div>

                <div v-else>
                    {{ Lang.get('employerdashboard::shared.sync.next_unscheduled') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sync: Object
    }
}
</script>
